import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useCart } from "../../CartContext";
const SingleProductDetails = ({ main }) => {
  const [inCart, setIncart] = useState([]);
  const { cart, addToCart, decreaseQuantity } = useCart();

  const {
    no,
    id,
    name,
    image,
    category,
    price,
    quantity,
    description,
    rating,
    totalquantity,
    overalltotalquantity,
  } = main;

  if (cart == []) {
    console.log("ok");
  }
  const a = cart.find((item) => item.id === id);

  // console.log(a.quantity);
  console.log(quantity);

  // const product = {
  //   id: id,
  //   name: name,
  //   price: price,
  //   quantity: quantityAmount,
  //   totalquantity: totalquantity,
  //   totalQuantityLeft: totalQuantityLeft,
  // };
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  // console.log(product);

  // const existingCart = JSON.parse(localStorage.getItem("carts")) || [];
  // const productIndex = cart.findIndex((main) => main.id === id);

  // if (productIndex !== -1) {
  //   cart[productIndex].quantity += quantity;
  //   cart[productIndex].totalQuantityLeft =
  //     totalquantity - cart[productIndex].quantity;
  // } else {
  //   cart.push(product);
  // }

  // localStorage.setItem("carts", JSON.stringify(cart));

  // reset form
  //   setQuantityAmount(1);
  //   // setTotalQuantityLeft(existingCart[productIndex].totalQuantityLeft);
  // };
  // localStorage.clear();
  console.log(cart.length);

  return (
    <div className="w-[100%] lg:w-[50%]">
      <h1 className="font-[600] text-[30px] mb-[5px]">{name}</h1>
      <h5 className="text-gray-500 font-[600] text-[17px] my-[5px]">
        ${price}.00
      </h5>
      <NavLink
        to={`/${category}`}
        className={"text-amber-500 font-[600] mb-[5px]"}
      >
        <span className="text-black">Category | </span> {category}
      </NavLink>
      <p className="text-gray-500 text-[17px] my-[10px]">{description}</p>
      <p
        className={`my-[10px] ${
          !a
            ? "text-green-500"
            : a.totalquantity < 5
            ? "text-red-500"
            : "text-green-500"
        }`}
      >
        {a
          ? a.totalquantity + " quantity left"
          : overalltotalquantity + " quantity left"}
      </p>
      <span className="text-amber-500">
        {Array.from({ length: rating }, (_, i) => (
          <i key={i} className="fa-solid fa-star mx-[2px]"></i>
        ))}
      </span>
      <br />
      {/* Add to Cart */}
      <div className="flex items-center gap-3 my-[15px]">
        <div>
          {!a ? (
            <button
              onClick={() => addToCart(main)}
              className="font-[600] bg-amber-500 text-white py-[10px] px-[15px] rounded-[5px] hover:bg-amber-600"
            >
              ADD TO CART
            </button>
          ) : (
            <div className="flex items-center gap-3">
              <button
                className="font-[600] bg-amber-500 text-white py-[10px] px-[15px] rounded-[5px] hover:bg-amber-600"
                onClick={() => decreaseQuantity(main.id)}
              >
                -
              </button>
              <p className="font-[600]">{a ? a.quantity : 0}</p>
              <button
                className="font-[600] bg-amber-500 text-white py-[10px] px-[15px] rounded-[5px] hover:bg-amber-600"
                onClick={() => addToCart(main)}
              >
                +
              </button>
            </div>
          )}
        </div>
        <NavLink
          to={"/cart-page"}
          onClick={() => {
            window.scrollTo({ top: 0 });
          }}
          className="font-[600] bg-gray-500 text-white py-[10px] px-[15px] rounded-[5px] hover:bg-gray-600"
        >
          VIEW CART
        </NavLink>
      </div>
      <p className="text-gray-500 font-[600] text-[16px] mb-[10px]">
        Share product via
      </p>
      <span className="flex">
        <a href="#">
          <i className="fa-brands fa-facebook-f mx-[3px] bg-white text-amber-500 h-[30px] w-[30px] flex flex-row items-center justify-center rounded-[50%] hover:bg-amber-500 hover:text-white transition-all duration-500 ease-in-out text-[20px]"></i>
        </a>
        <a href="#">
          <i className="fa-brands fa-x-twitter mx-[3px] bg-white text-amber-500 h-[30px] w-[30px] flex flex-row items-center justify-center rounded-[50%] hover:bg-amber-500 hover:text-white transition-all duration-500 ease-in-out text-[20px]"></i>
        </a>
        <a href="#">
          <i className="fa-brands fa-whatsapp mx-[3px] bg-white text-amber-500 h-[30px] w-[30px] flex flex-row items-center justify-center rounded-[50%] hover:bg-amber-500 hover:text-white transition-all duration-500 ease-in-out text-[20px]"></i>
        </a>
      </span>
    </div>
  );
};

export default SingleProductDetails;
